<template>
  <v-card>
    <v-card-title class="text-h6 mb-3">
      {{ $t("Gia hạn") }}
    </v-card-title>

    <v-card-text>
      <template v-if="step == 1">
        <v-row dense>
          <v-col cols="4">
            <v-text-field
              v-model.number="renewal.rent_day"
              class="c-input-small"
              dense
              outlined
              hide-details
              label="Ngày gia hạn"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model.number="renewal.rent_hour"
              class="c-input-small"
              dense
              outlined
              hide-details
              label="Giờ gia hạn"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <Voucher
              :key="`voucher_${renewal.id}`"
              v-model="renewal.id_voucher"
              :vouchers="vouchers"
              :id-country="renewal.id_country"
              :id-voucher="renewal.id_voucher"
              label="Voucher"
              class="c-input-small"
            />
            <!-- <v-autocomplete
              v-model="renewal.id_voucher"
              class="c-input-small"
              :items="voucherOptions"
              dense
              outlined
              hide-details
              label="Voucher"
            ></v-autocomplete> -->
          </v-col>
        </v-row>

        <div class="mt-5" v-if="order && order.id">
          <OrderDetail :order="order" />
        </div>
      </template>

      <template v-else-if="step == 2">
        <Payment :info="renewal" :is-branch="isBranch" :is-flat="true" />
      </template>

      <template v-else-if="step == 3">
        <Success :info="renewal" :is-flat="true" />
      </template>
    </v-card-text>

    <v-card-actions>
      <v-row dense>
        <v-col cols="6" v-if="[1, 2].includes(step)">
          <v-btn color="error" small block @click="resetAndClose">
            {{ $t("Hủy gia hạn") }}
          </v-btn>
        </v-col>

        <v-col cols="6" v-if="[1].includes(step)">
          <v-btn
            color="primary"
            small
            block
            @click="saveAndNext"
            :disabled="!renewal.rent_day && !renewal.rent_hour"
          >
            {{ $t("Tiếp") }}
          </v-btn>
        </v-col>

        <v-col col="6" v-if="[2].includes(step)">
          <v-btn color="warning" small block @click="goBack">
            {{ $t("Quay lại") }}
          </v-btn>
        </v-col>

        <v-col cols="12" v-if="[3].includes(step)">
          <v-btn color="purple" class="white--text" small block @click="close">
            {{ $t("Đóng") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import renewalMixin from "@/components/rent/renewalMixin";

export default {
  name: "CreateRenewal",
  components: {
    OrderDetail: () => import("@/components/common/OrderDetail"),
    Payment: () => import("@/components/rent/Payment"),
    Success: () => import("@/components/rent/Success"),
    Voucher: () => import("@/components/rent/Voucher"),
  },
  mixins: [renewalMixin],
  props: {
    selected: {
      type: Object,
      default: () => {},
    },
    isBranch: {
      type: Boolean,
      default: () => true,
    },
  },
  mounted() {
    this.code = this.selected.tracking_id;
    this.renewal = { ...this.renewal, id_branch: this.selected.id_branch };
    this.scanInput();
  },
  methods: {
    resetAndClose() {
      this.onReset();
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
